<div class="po-wrapper" *ngIf="hasSelectedPartner">
  <po-toolbar p-title="TOTVS Marketplace" />
  <po-menu p-logo="assets/images/brand.png" p-short-logo="assets/images/short-brand.png" [p-menus]="menus"
    [p-collapsed]="false" [p-automatic-toggle]="true" />
  <router-outlet />
</div>

<div *ngIf="!hasSelectedPartner">
  <router-outlet />
</div>